import AntdPopover from "antd/es/popover";

export type PopoverProps = React.ComponentProps<typeof AntdPopover>;

const Popover = AntdPopover;

export { Popover };
